import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'


const VerCategorias = ({ data, SeleccionarCategoria, baseUrl }) => {

	return (
		<div>
			<MDBTable hover responsive>
				<MDBTableHead>
					<tr>
						<th>Id</th>
						<th>Activo</th>
						<th>Categoría</th>
						<th>Imagen</th>
						<th></th>
					</tr>
				</MDBTableHead>
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td>{item.id}</td>
								<td>{item.activo === 'true' ? 'Si' : 'No'}</td>
								<td>{item.nombre}</td>
								<td><div className="ImgProducto">
									{item.imagen !== '' ?
										<img src={`${baseUrl}${item.imagen}`} /> :
										<img src={fotoVacia} />
									}
								</div>
								</td>
								<td className="tabla_funciones">
									<div className="col text-center">
										<button
											onClick={SeleccionarCategoria(item, 'editar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faEdit} size="lg" />
										</button>

										<button
											onClick={SeleccionarCategoria(item, 'eliminar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faTrashAlt} size="lg" />
										</button>
									</div>

								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerCategorias